// src/components/MaintenanceLists/constants.js

// Maintenance categories
export const MAINTENANCE_CATEGORIES = {
  'regular': 'Regular Maintenance',
  'consumables': 'Consumables',
  'repairs': 'Repairs',
  'upgrades': 'Upgrades/Accessories',
  'operating': 'Operating Costs'
};

// Subcategories for each maintenance category
export const MAINTENANCE_SUBCATEGORIES = {
  'regular': [
    { id: 'service', name: 'Service' },
    { id: 'mot', name: 'MOT' },
    { id: 'inspection', name: 'Inspection' },
    { id: 'other', name: 'Other' }
  ],
  'consumables': [
    { id: 'tyres', name: 'Tyres' },
    { id: 'brakes', name: 'Brakes' },
    { id: 'chain_sprockets', name: 'Chain/Sprockets' },
    { id: 'battery', name: 'Battery' },
    { id: 'lights', name: 'Lights' },
    { id: 'fluids', name: 'Fluids' },
    { id: 'other', name: 'Other' }
  ],
  'repairs': [
    { id: 'powertrain', name: 'Powertrain' },
    { id: 'electrical', name: 'Electrical' },
    { id: 'chassis', name: 'Chassis/Suspension' },
    { id: 'body', name: 'Body/Cosmetic' },
    { id: 'warranty', name: 'Warranty Work' },
    { id: 'other', name: 'Other' }
  ],
  'upgrades': [
    { id: 'performance', name: 'Performance' },
    { id: 'luggage', name: 'Luggage' },
    { id: 'comfort', name: 'Comfort' },
    { id: 'protection', name: 'Protection' },
    { id: 'electronics', name: 'Electronics' },
    { id: 'other', name: 'Other' }
  ],
  'operating': [
    { id: 'insurance', name: 'Insurance' },
    { id: 'road_tax', name: 'Road tax' },
    { id: 'registration', name: 'Registration fees' },
    { id: 'storage', name: 'Storage' },
    { id: 'fuel', name: 'Fuel' },
    { id: 'other', name: 'Other' }
  ]
};

/**
 * Get subcategory name from its ID
 */
export const getSubcategoryName = (category, subcategoryId) => {
  if (!category || !subcategoryId || !MAINTENANCE_SUBCATEGORIES[category]) {
    return '';
  }
  
  const subcategory = MAINTENANCE_SUBCATEGORIES[category].find(sub => sub.id === subcategoryId);
  return subcategory ? subcategory.name : subcategoryId;
};

/**
 * Format a cost value with currency
 */
export const formatCost = (cost) => {
  if (cost === null || cost === undefined) return '';
  return `£${parseFloat(cost).toFixed(2)}`;
};

/**
 * Format currency with locale support
 */
export const formatCurrency = (amount) => {
  return `£${amount.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};